import { type CSSProperties } from 'react';
import { GripVertical } from 'lucide-react';
import { cn } from '@/utils/cn';

/** Header-only 1px edge; resize hit-testing lives in `useRetailTableResize`. */
export const RETAIL_COLUMN_HEADER_EDGE_CLASS =
  'relative after:pointer-events-none after:absolute after:inset-y-0 after:right-0 after:w-px after:bg-[#D1D5DB] after:content-[""]';

export function RetailColumnHeader({
  label,
  columnId,
  align = 'left',
  className,
  style,
}: {
  label: string;
  columnId: string;
  align?: 'left' | 'right';
  className?: string;
  style?: CSSProperties;
}) {
  return (
    <th
      data-retail-col-id={columnId}
      style={style}
      className={cn(
        RETAIL_COLUMN_HEADER_EDGE_CLASS,
        align === 'right' ? 'text-right' : 'text-left',
        className
      )}
    >
      <div
        className={cn(
          'flex min-w-max items-center gap-2',
          align === 'right' ? 'justify-end' : 'justify-start'
        )}
      >
        <span
          className="inline-flex shrink-0 items-center text-foreground-muted/80"
          aria-hidden
        >
          <GripVertical className="h-4 w-4" />
        </span>
        <span className="flex shrink-0 items-center gap-1.5 text-foreground">
          <span data-retail-col-label="" className="whitespace-nowrap">
            {label}
          </span>
        </span>
      </div>
    </th>
  );
}
